/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment, useContext } from "react"
import { Link } from "react-router-dom"
import { Disclosure, Menu, Transition } from "@headlessui/react"
import {
    BellIcon,
    BeakerIcon,
    ChevronDownIcon,
    PencilIcon,
    PencilAltIcon,
    BriefcaseIcon,
    ChatIcon,
    CogIcon,
    FolderOpenIcon,
    LogoutIcon,
    QuestionMarkCircleIcon,
    MapIcon,
    SearchIcon,
    UserIcon,
    MenuIcon,
    XIcon,
    ChartPieIcon,
    HomeIcon,
} from "@heroicons/react/outline"
import { AuthContext } from "context/Auth"

// const navigation = ["Research", "Map", "Files"]
// const profile = ["Your Profile", "Settings", "Sign out"]

function classNames(...classes) {
    return classes.filter(Boolean).join(" ")
}

const pagelinks = [
    {
        title: "Map",
        icon: (
            <MapIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle" />
        ),
    },
    {
        title: "Database",
        icon: (
            <BriefcaseIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle" />
        ),
    },
    {
        title: "Files",
        icon: (
            <FolderOpenIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
        ),
    },
]

export default function Example() {
    const { currentUser, logoutUser } = useContext(AuthContext)
    console.log(currentUser)
    const handleSignOut = () => {
        logoutUser(history, "")
    }
    return (
        <div className="w-full fixed top-0 z-30">
            <Disclosure as="nav" className="bg-white shadow">
                {({ open }) => (
                    <>
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="flex items-center justify-between h-16">
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <Link to={`/app`}>
                                            <div className="mr-10 flex items-center">
                                                <img
                                                    alt="logo"
                                                    className="h-10 w-auto"
                                                    src="/assets/img/lsd_logo.gif"
                                                />
                                                <h3 className="text-base text-gray-600 font-bold tracking-normal leading-tight ml-3 block">
                                                    SIMS
                                                </h3>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <div className="hidden md:block">
                                        <ul className="ml-10 flex items-baseline space-x-4">
                                            <Link to={`/`}>
                                                <li className="p-2 flex items-center cursor-pointer text-gray-600 text-sm leading-3 tracking-normal rounded mx-2 hover:bg-indigo-200 focus:text-indigo-700 focus:outline-none hover:bg-indigo-200">
                                                    <span className="mr-2">
                                                        <HomeIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle" />
                                                    </span>
                                                    Home
                                                </li>
                                            </Link>
                                            {pagelinks.map((item, index) => (
                                                <Link
                                                    key={index}
                                                    to={
                                                        item.title === "admin"
                                                            ? `/admin`
                                                            : `/app/${item.title.toLowerCase()}`
                                                    }
                                                >
                                                    <li className="p-2 flex items-center cursor-pointer text-gray-600 text-sm leading-3 tracking-normal rounded mx-2 hover:bg-indigo-200 focus:text-indigo-700 focus:outline-none hover:bg-indigo-200">
                                                        <span className="mr-2">
                                                            {item.icon}
                                                        </span>
                                                        {item.title}
                                                    </li>
                                                </Link>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="ml-4 flex items-center md:ml-6">
                                        {/* <button className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                                            <span className="sr-only">
                                                View notifications
                                            </span>
                                            <BellIcon
                                                className="h-6 w-6"
                                                aria-hidden="true"
                                            />
                                        </button> */}

                                        {/* Profile dropdown */}
                                        <Menu as="div" className="z-20 ml-3 relative">
                                            {({ open }) => (
                                                <>
                                                    <div>
                                                        <Menu.Button className="max-w-xs flex items-center text-sm focus:outline-none focus:ring-white">
                                                            {/* <span className="sr-only">
                                                                Open user menu
                                                            </span> */}
                                                            <div className="rounded h-10 w-10 bg-gray-400 animate-pulse"></div>
                                                            <div className="text-left">
                                                                <p className="text-gray-600 text-sm ml-2">
                                                                    {
                                                                        currentUser?.user_name
                                                                    }
                                                                </p>
                                                                <p className="text-gray-600 text-sm ml-2">
                                                                    {
                                                                        currentUser?.user_role
                                                                    }
                                                                </p>
                                                            </div>
                                                        </Menu.Button>
                                                    </div>
                                                    <Transition
                                                        show={open}
                                                        as={Fragment}
                                                        enter="transition ease-out duration-100"
                                                        enterFrom="transform opacity-0 scale-95"
                                                        enterTo="transform opacity-100 scale-100"
                                                        leave="transition ease-in duration-75"
                                                        leaveFrom="transform opacity-100 scale-100"
                                                        leaveTo="transform opacity-0 scale-95"
                                                    >
                                                        <Menu.Items
                                                            static
                                                            className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                                        >
                                                            <ul className="border-r bg-white rounded left-0 shadow z-20">
                                                                <div className="block md:hidden">
                                                                    {pagelinks.map(
                                                                        (item, index) => (
                                                                            <Link
                                                                                key={
                                                                                    index
                                                                                }
                                                                                to={
                                                                                    item.title ===
                                                                                    "admin"
                                                                                        ? `/admin`
                                                                                        : `/app/${item.title.toLowerCase()}`
                                                                                }
                                                                            >
                                                                                <li className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal rounded mx-2 hover:bg-indigo-200 focus:text-indigo-700 focus:outline-none hover:bg-indigo-200">
                                                                                    <div className="flex items-center">
                                                                                        <span className="mr-2">
                                                                                            {
                                                                                                item.icon
                                                                                            }
                                                                                        </span>
                                                                                        {
                                                                                            item.title
                                                                                        }
                                                                                    </div>
                                                                                </li>
                                                                            </Link>
                                                                        )
                                                                    )}
                                                                </div>
                                                                {currentUser?.user_role.toLowerCase() ===
                                                                    "admin" && (
                                                                    <Link to={`/admin`}>
                                                                        <li className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal rounded mx-2 hover:bg-indigo-200 focus:text-indigo-700 focus:outline-none hover:bg-indigo-200">
                                                                            <div className="flex items-center">
                                                                                <ChartPieIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                                                                <span className="ml-2">
                                                                                    Admin
                                                                                </span>
                                                                            </div>
                                                                        </li>
                                                                    </Link>
                                                                )}

                                                                <Link to={`/app/profile`}>
                                                                    <li className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal rounded mx-2 hover:bg-indigo-200 focus:text-indigo-700 focus:outline-none hover:bg-indigo-200">
                                                                        <div className="flex items-center">
                                                                            <UserIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                                                            <span className="ml-2">
                                                                                My Profile
                                                                            </span>
                                                                        </div>
                                                                    </li>
                                                                </Link>
                                                                {/* <Link to={`/app/help`}>
                                                                    <li className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal mt-2 rounded mx-2 hover:bg-indigo-200 focus:text-indigo-700 focus:outline-none flex items-center hover:bg-indigo-200">
                                                                        <QuestionMarkCircleIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                                                        <span className="ml-2">
                                                                            Help Center
                                                                        </span>
                                                                    </li>
                                                                </Link> */}

                                                                <li
                                                                    onClick={() => {
                                                                        console.log(
                                                                            "sign out user"
                                                                        )
                                                                        handleSignOut()
                                                                    }}
                                                                    className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal mt-2 rounded mx-2 hover:bg-indigo-200 flex items-center focus:text-indigo-700 focus:outline-none hover:bg-indigo-200"
                                                                >
                                                                    <LogoutIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                                                    <span className="ml-2">
                                                                        Sign Out
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </Menu.Items>
                                                    </Transition>
                                                </>
                                            )}
                                        </Menu>
                                    </div>
                                </div>
                                {/* <div className="-mr-2 flex md:hidden">

                                    <Disclosure.Button className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                                        <span className="sr-only">Open main menu</span>
                                        {open ? (
                                            <XIcon
                                                className="block h-6 w-6"
                                                aria-hidden="true"
                                            />
                                        ) : (
                                            <MenuIcon
                                                className="block h-6 w-6"
                                                aria-hidden="true"
                                            />
                                        )}
                                    </Disclosure.Button>
                                </div> */}
                            </div>
                        </div>

                        <Disclosure.Panel className="md:hidden">
                            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                                {pagelinks.map((item, index) => (
                                    <Link
                                        key={index}
                                        to={
                                            item.title === "admin"
                                                ? `/admin`
                                                : `/app/${item.title}`
                                        }
                                    >
                                        <li className="py-2 capitalize cursor-pointer flex items-center text-base font-medium hover:text-indigo-700 text-gray-600 tracking-normal transition duration-150 ease-in-out">
                                            <span className="mr-2">{item.icon}</span>
                                            {item.title}
                                        </li>
                                    </Link>
                                ))}
                            </div>
                            <div className="pt-4 pb-3 border-t border-gray-700">
                                <ul className="mt-3 px-2 space-y-1">
                                    <li className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal py-2 hover:text-indigo-700 focus:text-indigo-700 focus:outline-none hover:bg-indigo-200">
                                        <div className="flex items-center">
                                            <UserIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                            <span className="ml-2">My Profile</span>
                                        </div>
                                    </li>
                                    <li className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal mt-2 py-2 hover:text-indigo-700 focus:text-indigo-700 focus:outline-none flex items-center hover:bg-indigo-200">
                                        <QuestionMarkCircleIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                        <span className="ml-2">Help Center</span>
                                    </li>
                                    <li
                                        onClick={() => {
                                            console.log("sign out user")
                                            handleSignOut()
                                        }}
                                        className="p-2 cursor-pointer text-gray-600 text-sm leading-3 tracking-normal mt-2 py-2 hover:text-indigo-700 flex items-center focus:text-indigo-700 focus:outline-none hover:bg-indigo-200"
                                    >
                                        <LogoutIcon className="h-5 w-5 stroke-current icon icon-tabler icon-tabler-puzzle " />
                                        <span className="ml-2">Sign Out</span>
                                    </li>
                                </ul>
                            </div>
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
    )
}
